import { create, type StateCreator } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

export interface Mui5BreakpointsSlice {
    mui5Breakpoints: boolean
}

export const createMui5BreakpointsSlice: StateCreator<Mui5BreakpointsSlice, [], [], Mui5BreakpointsSlice> = () => ({
    mui5Breakpoints: false,
})

export const useMui5BreakpointsStore = create<Mui5BreakpointsSlice>()(
    persist(
        devtools(createMui5BreakpointsSlice as any, {
            name: 'Mui5BreakpointsStore',
        }),
        { name: 'mui5-breakpoints' },
    ),
)

export const useMui5Breakpoints = () => useMui5BreakpointsStore((state) => state.mui5Breakpoints)
export const getMui5BreakpointsState = () => useMui5BreakpointsStore.getState().mui5Breakpoints
export const setMui5Breakpoints = (state: boolean) => useMui5BreakpointsStore.setState({ mui5Breakpoints: state })
export const toggleMui5Breakpoints = () => setMui5Breakpoints(!getMui5BreakpointsState())
